import React, { useState } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
//import walletmobileImage from "../../../assets/googlewallet/walletmobile.svg";
import walletmobileImage from "../../../assets/banner/belowwat.svg";
import { verifyWithGoogleWallet } from "src/services/googleWalletService";
import "./walletverify.css";
import { DarkButton, LightButton } from "src/styled-components/customButtons";

const GoogleWalletVerifier = ({ theme }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [alertData, setAlertData] = useState({});
  const profile = JSON.parse(sessionStorage.getItem("profileData"));
  const isMobile = window.matchMedia("(max-width: 575px)").matches;

  const handleVerifyClick = async () => {
    if (isLoading) return;
    setIsLoading(true);
    const result = await verifyWithGoogleWallet(theme);
    setIsLoading(false);
    if (result.cancelled) return;
    setAlertData(result);
    setShowAlert(true);
  };

  return (
    <div className="googlewallet-verify-button">
      <img src={walletmobileImage} alt="Google Wallet" className="walletimage" />
      <div className="wallet-content">
        <span>{profile?.data?.google_button_text || "Get Verified with Google ID!"}</span>
        <p>Unlock exclusive benefits</p>
        {!isMobile && (
          <button
            onClick={handleVerifyClick}
            disabled={isLoading}
            className="google-wallet-loader"
          >
            {isLoading ? "Verifying..." : "Verify"}
          </button>
        )}
      </div>
      {isMobile && (
        <button
          onClick={handleVerifyClick}
          disabled={isLoading}
          className="google-wallet-loader"
        >
          {isLoading ? "Verifying..." : "Verify"}
        </button>
      )}

      {showAlert && (
        <SweetAlert
          custom
          show={showAlert}
          title=""
          onConfirm={() => setShowAlert(false)}
          showConfirm={false}
          maskClassName="swal-google-style"
        >
          <div className="custom-alert-container">
            <div className="alert-icon-wrapper">
              <img src={alertData.icon} alt="status" className="alert-icon-img" />
            </div>
            <h2 className="alert-title-text">{alertData.title}</h2>
            <p className="alert-msg-text">{alertData.msg}</p>
            {alertData.subMsg && (
              <p className="alert-submsg-text">{alertData.subMsg}</p>
            )}
            <div className="alert-actions-wrapper">
              <DarkButton
                className="btn-primary-yellow"
                onClick={() => {
                  setShowAlert(false);
                  if (alertData.success === "error") {
                    handleVerifyClick();
                  } else if (alertData.success === "success") {
                    window.location.reload();
                  }
                }}
              >
                {alertData.button_text}
              </DarkButton>
              {alertData.success === "error" && (
                <button
                  className="btn-verify-later"
                  onClick={() => setShowAlert(false)}
                >
                  Verify Later
                </button>
              )}
            </div>
          </div>
        </SweetAlert>
      )}
    </div>
  );
};

export default GoogleWalletVerifier;